'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Image = require('material-ui-icons/Image');

var _Image2 = _interopRequireDefault(_Image);

var _ = require('../../../../..');

var _2 = _interopRequireDefault(_);

var _ListView = require('../../ListView');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ObjectImage = (_temp = _class = function (_EditorComponent) {
  _inherits(ObjectImage, _EditorComponent);

  function ObjectImage() {
    _classCallCheck(this, ObjectImage);

    return _possibleConstructorReturn(this, _EditorComponent.apply(this, arguments));
  }

  ObjectImage.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelButton
    }, _react2.default.createElement(_Image2.default, null), ' Object Image'));
  };

  ObjectImage.prototype.getRootElement = function getRootElement() {
    return "span";
  };

  ObjectImage.prototype.renderMainView = function renderMainView() {
    var _getEditorContext2 = this.getEditorContext(),
        inEditMode = _getEditorContext2.inEditMode;

    if (!inEditMode) {
      return this.renderChildren();
    } // else


    return _EditorComponent.prototype.renderMainView.call(this);
  };

  ObjectImage.prototype.renderChildren = function renderChildren() {
    var _this2 = this;

    var Image = this.context.Image; // {...this.getRenderProps()}

    return _react2.default.createElement(_ListView.ObjectContext.Consumer, null, function (context) {
      var object = context.object,
          other = _objectWithoutProperties(context, ['object']);

      if (!object) {
        return null;
      }

      var image = object.image;
      /**
        Если нет картинки, то смотрим на текущий режим.
        Если в режиме редактирования работаем, 
       */

      if (!image) {
        return null;
      }

      return _react2.default.createElement(Image, _extends({}, _this2.getComponentProps(_this2), {
        src: image
      }));
    });
  };

  return ObjectImage;
}(_2.default), _class.defaultProps = _extends({}, _2.default.defaultProps, {
  field_name: "image",
  type: 'thumb',
  style: _extends({}, _2.default.defaultProps.style, {
    maxWidth: "100%"
  }),
  hide_wrapper_in_default_mode: true
}), _class.Name = "ObjectImage", _temp);
exports.default = ObjectImage;
module.exports = exports['default'];